import { render, staticRenderFns } from "./emolument-location.vue?vue&type=template&id=33c8fccd"
import script from "./emolument-location.vue?vue&type=script&lang=js"
export * from "./emolument-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports